<div class="row justify-content-md-center notification {{type}}">
    <div *ngIf="html" [innerHTML]="html" class="col-xl-10 col-sm-12"></div>
    <div *ngIf="message" class="col-xl-10 col-sm-12">{{message}}</div>
</div>
